import React from "react";

let debug: (...args: any) => void;

if (process.env.NODE_ENV === "production" && !sessionStorage.getItem("DEBUG")) {
  debug = (..._args) => {};
} else {
  debug = (...args) => console.debug(...args);
}

export function usePrintSecondsSinceLastMount(identifier: string) {
  const ref = React.useRef(0);
  const seconds = ref.current;

  if (ref.current < 50) {
    debug(`${identifier}, seconds since last mount: ${seconds}`);
  }

  React.useEffect(() => {
    const timer = setInterval(() => (ref.current = ref.current + 1), 1000);
    return () => {
      debug(`${identifier}: #useEffect cleanup (mounted ${ref.current} seconds ago)`);
      clearInterval(timer);
    };
  }, [seconds, identifier]);
}

export function createRenderingInfoPrinter(identifier: string, printSecondsSinceMount = true) {
  let count = 0;
  return () => {
    count++;
    debug(`${identifier}: rendering (total: #${count}`);
    if (printSecondsSinceMount) usePrintSecondsSinceLastMount(identifier);
  };
}

/**
 * when cleaning up the Ninestack mess of {props:any} we often have no idea what
 * a function is to be used for or when. Set the value to this util to see when it is
 * used. Essentially, a shipped product should have 0 uses of this utility!
 */
export function triggerDebuggerAndThrow(optionalMessage?: string) {
  debugger;
  throw new TypeError(optionalMessage || "Is this used!?");
}
